import type { SvgIconProps } from '@ori-ui/mui';
import { SvgIcon } from '@ori-ui/mui';

export function Visa(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g
        id="visa"
        transform="matrix(0.0974543,0,0,0.0974543,-0.78551,6.12906)"
      >
        <path
          id="polygon9"
          d="M116.145,95.719L97.858,95.719L109.296,24.995L127.582,24.995L116.145,95.719Z"
          style={{ fill: 'rgb(0,87,159)', fillRule: 'nonzero' }}
        />
        <path
          id="path11"
          d="M182.437,26.724C178.83,25.293 173.109,23.713 166.035,23.713C147.976,23.713 135.259,33.343 135.181,47.111C135.031,57.269 144.286,62.911 151.208,66.298C158.283,69.759 160.688,72.018 160.688,75.103C160.616,79.841 154.971,82.025 149.706,82.025C142.405,82.025 138.493,80.899 132.548,78.263L130.14,77.133L127.581,93.009C131.87,94.963 139.772,96.697 147.976,96.773C167.164,96.773 179.656,87.292 179.804,72.62C179.877,64.569 174.99,58.4 164.454,53.359C158.058,50.123 154.141,47.941 154.141,44.63C154.216,41.62 157.454,38.537 164.674,38.537C170.619,38.386 174.987,39.815 178.296,41.245L179.95,41.996L182.437,26.724Z"
          style={{ fill: 'rgb(0,87,159)', fillRule: 'nonzero' }}
        />
        <path
          id="path13"
          d="M206.742,70.664C208.248,66.601 214.043,50.876 214.043,50.876C213.967,51.027 215.546,46.738 216.449,44.105L217.727,50.199C217.727,50.199 221.19,67.128 221.942,70.664L206.742,70.664ZM229.315,24.995L215.17,24.995C210.808,24.995 207.494,26.273 205.612,30.863L178.449,95.718L197.637,95.718C197.637,95.718 200.796,86.989 201.475,85.109L224.954,85.109C225.479,87.592 227.136,95.718 227.136,95.718L244.068,95.718L229.315,24.995Z"
          style={{ fill: 'rgb(0,87,159)', fillRule: 'nonzero' }}
        />
        <path
          id="path15"
          d="M82.584,24.995L64.675,73.222L62.718,63.441C59.407,52.155 49.023,39.893 37.435,33.796L53.839,95.644L73.177,95.644L101.921,24.995L82.584,24.995Z"
          style={{ fill: 'rgb(0,87,159)', fillRule: 'nonzero' }}
        />
        <path
          id="path17"
          d="M48.045,24.995L18.623,24.995L18.322,26.424C41.273,32.293 56.473,46.44 62.718,63.444L56.322,30.94C55.269,26.423 52.033,25.144 48.045,24.995Z"
          style={{ fill: 'rgb(250,166,26)', fillRule: 'nonzero' }}
        />
      </g>
    </SvgIcon>
  );
}
